const locales = {
  EN: "en",
  UA: "ua",
} as Record<string, string>;

export { locales };
